﻿import {translation} from "@2d-front-monorepo/core";
import {
	AttachmentStatusComponent,
	attachmentTypeLabel,
	EntityDocument,
	formatDateTime,
	InstallationByHostData,
	residencyToCompactString,
	Tariffs
} from "@2d-front-monorepo/permits-business";
import {JSX} from "react";

type DocumentControlProps = {
	document: EntityDocument;
	installation: InstallationByHostData;
	actions?: JSX.Element;
}

function EntityControl({document, installation}: DocumentControlProps): JSX.Element {
	const {entityType, entity} = document;

	switch (entityType) {
		case "holder":
			return <>{entity.email}</>;

		case "permit":
			return <>{Tariffs.get(installation, entity.tariffId).title}</>;

		case "reservation":
			return <>{Tariffs.get(installation, entity.tariffId).title}</>;

		case "driver":
			return <>{entity.fullName}</>;

		case "residency":
			return <>{residencyToCompactString(entity)}</>;

		case "vehicle":
			return <>{entity.plate}</>;
	}
}

export default function DocumentControl(props: DocumentControlProps): JSX.Element {
	const {document, installation, actions} = props;
	const {entityType, attachment} = document;

	return (
		<tr>
			<td className="text">{translation(attachmentTypeLabel(attachment.type))}</td>
			<td>{translation("entity__type--" + entityType)}</td>
			<td><EntityControl document={document} installation={installation}/></td>
			<td className="date">{attachment.expires == null ? "" : formatDateTime(attachment.expires)}</td>
			<td><AttachmentStatusComponent attachment={attachment} small={false}/></td>
			<td className="actions">{actions}</td>
		</tr>);
}
